import type { RouteObject } from 'react-router-dom';

import { lazy, Suspense } from 'react';

const ContactPage = lazy(() =>
  import('./pages/contact-page').then((m) => ({ default: m.ContactPage })),
);

export const contactRoutes: RouteObject[] = [
  {
    path: 'contact',
    element: (
      <Suspense fallback={null}>
        <ContactPage />
      </Suspense>
    ),
  },
];
